import styled from 'styled-components';
import { COLORS, breakPoint } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import RadioButton from '@ertelecom/ui-react/components/controls/radioButton';

export const Wrapper = styled.div`
  width: 100%;
  display: block;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.07);
  }
`;

export const Body = styled.div`
    border-left: 1px solid ${COLORS.outlineGrey};
    border-right: 1px solid ${COLORS.outlineGrey};
    border-bottom: 1px solid ${COLORS.outlineGrey};
    border-radius: 0 0 8px 8px;
    background-color: ${COLORS.white};
    padding: 18px 20px 20px;
    min-height: 221px;
    display: flex;
    flex-direction: column;
`;

export const StyledRadioButton = styled(RadioButton)`
    width: 100%;
    font-size: 14px;

    & + & {
        margin-top: 6px;
    }
`;

export const Button = styled(StyledButton)`
    width: 100%;
    margin-top: auto;
    padding: 10px 24px;
`;

export const Header = styled.div`
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    position: relative;
    padding: 23px 20px;
    background: ${props => props.background ? props.background : COLORS.lightRed };
    height: 275px;
    display: block;

    @media(${breakPoint(320)}) {
        height: 281px;
    }
`;

export const PackageInfo = styled.div`
    display: flex;
    flex-wrap: nowrap;
    border-bottom: 1px solid rgba(255,255,255, 0.4);
    min-height: 95px;
    align-items: flex-start;

    @media(${breakPoint(1024)}) {
        min-height: 90px;
    }
`;

export const BaseInfo = styled.div`
    display: block;
    padding-right: 10px;
`;

export const LogoWrapper = styled.div`
    width: 126px;
    height: 89px;
    position: relative;
    flex-shrink: 0;
    margin-left: auto;
    display: block;
    margin-top: -5px;

    @media(${breakPoint(1366)}) {
        width: 133px;
        height: 90px;
    }

    @media(${breakPoint(1024)}) {
        width: 139px;
        height: 102px;
        margin-right: -10px;
        margin-top: -13px;
    }

    @media(${breakPoint(768)}) {
        width: 125px;
        height: 103px;
    }

    @media(${breakPoint(320)}) {
        width: 116px;
        height: 97px;
    }
`;

export const Logo = styled.img`
    max-width: 100%;
    max-height: 100%;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const Title = styled.span`
    font: 400 20px/21px "Roboto", sans-serif;
    color: ${COLORS.white};
    display: block;

    @media(${breakPoint(1024)}) {
        font-size: 16px;
        line-height: 20px;
    }
`;

export const Subtitle = styled.span`
    font: 400 14px/18px "Roboto", sans-serif;
    color: ${COLORS.white};
    display: block;
    margin-top: 11px;

    @media(${breakPoint(1024)}) {
        font-size: 12px;
        line-height: 16px;
    }
`;

export const ChannelsList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-left: -10px;
    margin-right: -10px;
    padding-top: 8px;

    @media(${breakPoint(1024)}) {
        padding-top: 11px;
    }
`;

export const Channel = styled.li`
    display: block;
    width: 50%;
    padding: 0 10px;

    & + & {
        margin-top: 3px;

        @media(${breakPoint(1024)}) {
            margin-top: 1px;
        }
    }
`;

export const ChannelLink = styled.a`
    font: 400 12px/18px "Roboto", sans-serif;
    color: ${COLORS.white};
    display: inline-block;
    border-bottom: 1px dotted ${COLORS.white};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    transition: color 0.3s ease, border-color 0.3s ease;

    &:hover {
        color: ${COLORS.grey};
        border-color: ${COLORS.grey};
    }
`;

export const ToolTipInner = styled.div`
    display: block;
    box-sizing: border-box;
    max-width: 430px;
    position: relative;
    padding: 22px;

    @media (max-width: 640px) {
        width: 280px;
    }
`;

export const ToolTipClose = styled.button`
    position: absolute;
    width: 16px;
    height: 16px;
    right: 7px;
    top: 7px;
    appearance: none;
    border: none;
    background-color: transparent;
    background-size: cover;
    background-position: center;
    cursor: pointer;
    outline: none;
`;

export const TooltipTitle = styled.a`
    display: inline-block;
    text-decoration: none;
    color: ${COLORS.blue};
    font: 400 20px/1 "Roboto", sans-serif;
    padding-bottom: 3px;
    border-bottom: 1px solid ${COLORS.blue};
`;

export const TooltipSubtitle = styled.span`
    font: 400 14px/20px "Roboto", sans-serif;
    display: block;
    color: rgba(12, 12, 12, 0.5);
    margin-top: 12px;
`;

export const TooltipText = styled.div`
    font: 300 14px/20px "Roboto", sans-serif;
    display: block;
    color: ${COLORS.black};
    margin-top: 11px;
`;
